import React from 'react';
import {
    Select,
    Stack,
    Autocomplete,
    Icon
} from '@shopify/polaris';
import { SearchMinor } from '@shopify/polaris-icons';
import { SelectFilterTypes } from '../common/Helpers';

const smartCollectionOptions = [
    { label: 'was processed by', value: 'Processed' },
    { label: 'was not processed', value: 'NotProcessed' },
];

class ProcessedByOperationFilterComponent extends React.Component {

    state = {

    };

    constructor(props) {
        super(props)

        const selectedItem = this.findSelectedItem(this.props.filter.tagOperationId);

        this.state = {
            searchText: selectedItem != null ? selectedItem.name : ""

        }
    }

    render() {

        const selectedItem = this.findSelectedItem(this.props.filter.tagOperationId);
        const showAllOperations = selectedItem != null && selectedItem.name === this.state.searchText;


        let tagOperations = this.props.tagOperations
            .filter(_ => {

                if (this.state.searchText === '' || showAllOperations) {
                    return true;
                }

                const filterRegex = new RegExp(this.state.searchText, 'i');
                return _.name.match(filterRegex)
            })
            .map((_) => {
                return { "label": _.name, "value": _.id };
            }
            );

        const textField = (
            <Autocomplete.TextField
                onChange={this.onUpdateText}
                value={this.state.searchText}
                prefix={<Icon source={SearchMinor} color="base" />}
                placeholder="Select Tag Operation"
            />
        );

        return (<Stack alignment="center" spacing="tight">
            <Select
                options={SelectFilterTypes}
                value={this.props.filter.filterType}
                onChange={(selected, id) => this.onFilterTypeChange(selected)}
            />
            <Select
                options={smartCollectionOptions}
                value={this.props.filter.condition}
                onChange={(selected, id) => this.onConditionChange(selected)}
            />
            <Stack.Item fill>
                <Autocomplete
                    options={tagOperations}
                    selected={[this.props.filter.tagOperationId]}
                    onSelect={this.onUpdateSelection}
                    textField={textField}
                />
            </Stack.Item>
            {/* <Select
                options={allCollectionItems}
                value={this.props.filter.tagOperationId}
                onChange={(selected, id) => this.onTagOperationIdChange(selected)}
            /> */}
        </Stack>);
    }

    onUpdateSelection = (selected) => {

        if (selected.length === 0) {
            this.onTagOperationIdChange(null);
            this.setState({
                searchText: null
            });
        }
        else {

            const selectedValue = selected[0];
            const selectedItem = this.findSelectedItem(selectedValue);
            this.setState({
                searchText: selectedItem.name
            });
            this.onTagOperationIdChange(selectedItem.id);
        }
    }

    findSelectedItem = (id) => {
        const selected = this.props.tagOperations.find(_ => _.id === id);

        return selected;
    }

    onUpdateText = (value) => {

        this.setState({
            searchText: value
        });
    }


    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.condition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onTagOperationIdChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.tagOperationId = newValue;

        this.props.onFilterUpdated(newFilter);
    }
}

export default ProcessedByOperationFilterComponent;
